
import React from 'react';

const RefinanceProgramsSection: React.FC = () => {
  const programs = [
    {
      title: 'Rate-and-Term Refinance',
      description: 'Replace your current loan with better terms, lower rates, or different loan duration.',
      features: ['Lower interest rates', 'Adjust loan term', 'Reduce monthly payments', 'Switch loan types']
    },
    {
      title: 'Cash-Out Refinance',
      description: 'Tap into your home equity for renovations, debt consolidation, or investments.',
      features: ['Access home equity', 'Fund renovations', 'Investment opportunities', 'Education expenses']
    },
    {
      title: 'Debt Consolidation Refinance',
      description: 'Roll high-interest debts into one affordable mortgage payment with better terms.',
      features: ['Combine all debts', 'Lower overall interest', 'Single payment', 'Improve credit score']
    },
    {
      title: 'Switching Lenders',
      description: 'Find a lender with more competitive rates, better service, or improved terms.',
      features: ['Better rates', 'Improved service', 'Flexible terms', 'No penalty switching']
    }
  ];

  return (
    <section className="py-20 bg-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Types of Refinance Programs
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We'll help you choose the option that fits your needs and financial goals.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {programs.map((program, index) => (
            <div 
              key={index}
              className="bg-gray-900 rounded-xl p-8 hover:shadow-lg transition-all duration-300 border border-gray-700 hover:border-red-500"
            >
              <h3 className="text-2xl font-bold text-white mb-4">
                {program.title}
              </h3>
              
              <p className="text-gray-300 mb-6 leading-relaxed">
                {program.description}
              </p>
              
              <ul className="space-y-3">
                {program.features && program.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-gray-300">
                    <div className="w-2 h-2 bg-red-600 rounded-full mr-3 flex-shrink-0"></div>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default RefinanceProgramsSection;
